import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=db8873aa&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db8873aa')) {
      api.createRecord('db8873aa', component.options)
    } else {
      api.reload('db8873aa', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=db8873aa&", function () {
      api.rerender('db8873aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uOebKgNnxCfQ/JS/comp/ImgFallback.vue"
export default component.exports